import React, {useEffect, useState} from "react";
import useApiCallService from "../../Common/Helpers/ApiCall";
import {AttestDetailView} from "../Components/Detail/AttestDetailView";
import {Col, Row} from "reactstrap";
import {CustomButton} from "../../Common/Components/Button/CustomButton";
import {ADMIN_PATHS, ORGANIZATION_PATHS} from "../../config";
import {useTranslation} from "react-i18next";
import {useLocation, useNavigate} from "react-router-dom";
import AdminRequestAttestApprovedModel from "../Model/Request/AdminRequestAttestApprovedModel";
import {FlashMessage} from "../../Common/Helpers/FlashMessage";
import AdminResponseAttestModel from "../Model/Response/AdminResponseAttestModel";
import AdminRequestAttestDenyModel from "../Model/Request/AdminRequestAttestDenyModel";
import {CustomReload} from "../../AppSystem/Helpers/CustomReload";
import $ from "jquery";
import {FlashMessageInsufficientAccountAmount} from "../../Common/Helpers/FlashMessageInsufficientAccountAmount";
import { useHeader } from "../../Auth/Components/Nav/HeaderContext";
import { CheckMobile } from "../../AppSystem/Helpers/CheckMobile";

export function AdminAttestInfo() {
    const { ApiCall } = useApiCallService();
    const idValue = new URLSearchParams(window.location.search).get('id');
    const fromValue = new URLSearchParams(window.location.search).get('from') ?? '';
    const admindigitalaccount = new URLSearchParams(window.location.search).get('admindigitalaccount') ?? '';
    const admindigitalaccountview = new URLSearchParams(window.location.search).get('admindigitalaccountview') ?? '';
    const digitalaccount = new URLSearchParams(window.location.search).get('digitalaccount') ?? '';
    // Payment open in the payout list the attest was opened from, reopened on the way back.
    const paymentIdValue = new URLSearchParams(window.location.search).get('paymentId') ?? '';
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const isMobile = CheckMobile(998);
    const { setPageTitle, setPageTitleKey, setOnBack } = useHeader();

    useEffect(() => {
        setPageTitle(t('attest.attest'));
        setPageTitleKey('attest.attest');
        setOnBack(handleBackClick);

        return () => {
            setPageTitle('');
            setPageTitleKey('');
            setOnBack(null);
        };
    }, [fromValue, admindigitalaccount, admindigitalaccountview, digitalaccount, paymentIdValue, t]);
    
    const [page, setPage] = useState(1);
    const perpage = 10;
    const [sortConfig, setSortConfig] = useState({ key: 'CreatedAt', direction: 'desc' });
    const handleSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
        setPage(1); 
    };
    const [isLoading, setIsLoading] = useState(false);
    // API REQUEST
    const [apiRequestAcceptAttest, setApiRequestAcceptAttest] = useState(new AdminRequestAttestApprovedModel());
    const [apiRequestDenyAttest, setApiRequestDenyAttest] = useState(new AdminRequestAttestDenyModel());
    const [relatedAttestData, setRelatedAttestData] = useState(null);

    //API RESPONSE
    const [apiResponseAttest, setApiResponseAttest] = useState(new AdminResponseAttestModel());
    const [apiResponseAttest2, setApiResponseAttest2] = useState(null);

    const completeSchemaAccept = AdminRequestAttestApprovedModel.getAttributes( null, true);
    const completeSchemaDeny = AdminRequestAttestDenyModel.getAttributes( null, true);

    const [showConfirmModalApprove, setShowConfirmModalApprove] = useState(false);
    const [showConfirmModalDeny, setShowConfirmModalDeny] = useState(false);

    const [errorReason, setErrorReason] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [type, setType] = useState('');

    useEffect(() => {
        const handleApiResponseAttest = (apiResponseAttest) => {
            setApiResponseAttest(apiResponseAttest);
        };
    
        const GetInfoAttest = async () => {
            if (idValue !== null) {
                try {
                    const apiCallOptions = {
                        method: "get",
                        url: `/attest/admin?id=${idValue}`,
                    };
                    await ApiCall(apiCallOptions, handleApiResponseAttest);
                } catch (error) {
                    console.log("error:", error);
                }
            }
        };
    
        GetInfoAttest();
    }, [idValue]);    

    useEffect(() => {    
        if (!apiResponseAttest || !apiResponseAttest.model) {
            return;
        }
    
        const fetchRelatedAttestData = async () => {
            if (
                apiResponseAttest?.createdBy &&
                (apiResponseAttest?.model === "Förrättning" || apiResponseAttest?.model === "Arvode")
            ) {
                try {
                    setIsLoading(true);
                    const createdByParam =
                        apiResponseAttest.model === "Arvode" && apiResponseAttest.modelInfo
                            ? apiResponseAttest.modelInfo.userId
                            : apiResponseAttest.createdBy;
                
                    if (!createdByParam) {
                        return;
                    }
        
                    const apiCallOptions = {
                        method: "get",
                        url: `/attest/admin/search-related-attest?createdBy=${createdByParam}&model=${apiResponseAttest.model}&page=${page}&perpage=${perpage}&sortBy=${sortConfig.key}&sortDirection=${sortConfig.direction}`,
                    };
        
                    await ApiCall(apiCallOptions, (response) => {
                        setRelatedAttestData(response);
                    });
                } catch (error) {
                    console.log("Error fetching related attest data:", error);
                } finally {
                    setIsLoading(false);
                }
            }
        };
    
        fetchRelatedAttestData();
    }, [apiResponseAttest, page, sortConfig]);       
    
    const handlePageChange = (newPage) => {
        setPage(newPage);
    };

    // PUT APPROVED
    const handleValidation = async (value) => {
        try {
            setType(value);
            if (value === "approve") {
                await completeSchemaAccept.validate(apiRequestAcceptAttest, { abortEarly: false });
            } else {
                await completeSchemaDeny.validate(apiRequestDenyAttest, { abortEarly: false });
            }
            const apiCallOptions = {
                method: value === "approve" ? "put" : "delete",
                url: "/attest/admin",
                data: value === "approve" ? apiRequestAcceptAttest : apiRequestDenyAttest,
            };
            try {
                await ApiCall(apiCallOptions, setApiResponseAttest2, setErrorMessage);
            } catch (error) {
                console.log(error);
                FlashMessage(t('validationMessage.sendError'), 'flash-messageError');
            }
        } catch (err) {
            setErrorReason(true);
            console.log(err)
        }
    }

    useEffect(() => {
        if (apiResponseAttest2) {

            // Delete localStorage keys related to adminAttest
            try {
                if (typeof window !== 'undefined' && window.localStorage) {
                    Object.keys(window.localStorage).forEach(key => {
                        if (key.startsWith('adminAttest')) {
                            window.localStorage.removeItem(key);
                        }
                    });
                }
            } catch (e) {
                console.warn('Error clearing adminAttest keys from localStorage', e);
            }

            if (type === "approve") {
                FlashMessage(t('validationMessage.attestApproved'), 'flash-messageSuccess');
                setShowConfirmModalApprove(false);
                $("#btnApproveAttest").removeClass("disabled");
                $(`#${apiResponseAttest.id}`).removeClass("disabled");
                $(".att-action-btn").removeClass("disabled");
            } else {
                setShowConfirmModalDeny(false);
                FlashMessage(t('validationMessage.attestDenied'), 'flash-messageSuccess');
                $("#btnApproveAttest").removeClass("disabled");
                $(`#${apiResponseAttest.id}`).removeClass("disabled");
                $(".att-action-btn").removeClass("disabled");
            }

            setTimeout(() => {
                CustomReload();
            }, 2000);
        }
    }, [apiResponseAttest2]);

    const handleChangeAttest = () => {
        setApiRequestAcceptAttest((prevFormData) => ({
            ...prevFormData,
            id: apiResponseAttest.id,
            attested: true,
            comment: '',
        }))
    }

    // HANDLE APPROVE COMMENT (optional)
    const handleChangeApproveComment = (e) => {
        const value = e?.target?.value ?? '';
        setApiRequestAcceptAttest((prevFormData) => ({
            ...prevFormData,
            comment: value,
        }))
    }

    // HANDLE DENY
    const handleChangeAttestDenyId = (id) => {
        setApiRequestDenyAttest((prevFormData) => ({
            ...prevFormData,
            id: id,
        }))
    }

    // HANDLE DENY REASON
    const handleChangeAttestDenyReason = (e) => {
        if (e && e.target && e.target.value && e.target.value !== "") {
            setApiRequestDenyAttest((prevFormData) => ({
                ...prevFormData,
                reason: e.target.value,
            }))
            setErrorReason(false);
        } else {
            setErrorReason(true);
        }
    }

    // ERROR MESSAGES
    useEffect(() => {
        if (errorMessage !== '') {
            if (errorMessage.includes("{")) {
                FlashMessage(<FlashMessageInsufficientAccountAmount jsonString={errorMessage} />, 'flash-messageError', 10000,true);
            }
            else {
                if (errorMessage === 'InsufficientBalance') {
                    FlashMessage(t('validationMessage.insufficientBalance'), 'flash-messageError');
                }
                if (errorMessage === 'UserNeedBankAccount') {
                    FlashMessage(t('validationMessage.notAccount'), 'flash-messageError');
                }
            }
            setTimeout(() => {
                $("#btnApproveAttest").removeClass("disabled");
                $(`#${apiResponseAttest.id}`).removeClass("disabled");
                $(".att-action-btn").removeClass("disabled");
            }, errorMessage.includes("{") ? 10000 : 2000);
            setErrorMessage('');
        }
    }, [errorMessage]);

    const handleBackClick = () => {
    // Opened from another page that wants Back to return there (e.g. the admin user page)
    if (location.state?.returnTo) {
        navigate(location.state.returnTo);
    } else if (admindigitalaccount) {
        navigate(ADMIN_PATHS.DIGITAL_ACCOUNT_LIST); 
    } else if (admindigitalaccountview) {
        navigate(ADMIN_PATHS.DIGITAL_ACCOUNT_VIEW);
    } else if (digitalaccount) {
        navigate(ORGANIZATION_PATHS.DIGITAL_ACCOUNT);
    } else if (fromValue === "bankTransfer") {
        navigate(`${ADMIN_PATHS.BANK_TRANSFERS_LIST}?paymentId=${paymentIdValue}`);
    } else if (fromValue === "bankTransferHistory") {
        navigate(`${ADMIN_PATHS.BANK_TRANSFERS_HISTORY_LIST}?paymentId=${paymentIdValue}`);
    } else {
        const targetPath = fromValue === "history" 
            ? ADMIN_PATHS.ATTEST_LIST_HISTORY 
            : (fromValue === "primary" ? ADMIN_PATHS.ATTEST_LIST_PENDING_PRIMARY : ADMIN_PATHS.ATTEST_LIST_PENDING);
        navigate(targetPath);
    }
};

    return (
        <>
            {!isMobile && (
                <Col lg={12}>
                    <CustomButton
                        text={t('button.back')}
                        icon={'bx bx-chevron-left'}
                        buttonSize={'small'}
                        customClasses={'ms-3 mb-3'}
                        onClick={handleBackClick}
                        // onClick={() => {
                        //     navigate(fromValue === "history" ? ADMIN_PATHS.ATTEST_LIST_HISTORY : (fromValue === "primary" ? ADMIN_PATHS.ATTEST_LIST_PENDING_PRIMARY : ADMIN_PATHS.ATTEST_LIST_PENDING))
                        // }}
                    />
                </Col>
            )}
            {(apiResponseAttest !== null && apiResponseAttest.id !== '') ?
                <AttestDetailView idParam={idValue} relatedData={relatedAttestData} data={apiResponseAttest} onChange={handleChangeAttest} onChangeApproveComment={handleChangeApproveComment} onValidate={handleValidation} onChangeDenyId={handleChangeAttestDenyId} onchangeDenyReason={handleChangeAttestDenyReason} setErrorReason={setErrorReason} errorReason={errorReason} setShowConfirmModalApprove={setShowConfirmModalApprove} showConfirmModalApprove={showConfirmModalApprove} setShowConfirmModalDeny={setShowConfirmModalDeny} showConfirmModalDeny={showConfirmModalDeny} onPageChange={handlePageChange} sortConfig={sortConfig} onSort={handleSort} page={page} setPage={setPage} isLoading={isLoading}/>
                : ''}

        </>
    );

}